'use client';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';

import { useMobileNavigation } from './contexts';

export function MobileNavigationCloseButton({ label }: { label: string }) {
    const isOpen = useMobileNavigation((s) => s.isOpen);
    const close = useMobileNavigation((s) => s.close);

    return (
        <Button
            className="size-[52px] p-xs text-3xl"
            aria-controls={isOpen ? 'mobile-menu' : undefined}
            aria-expanded={isOpen}
            aria-haspopup
            aria-label={label}
            onClick={close}
        >
            <Icon>close</Icon>
        </Button>
    );
}
